export var mutations = {
    setPassword: function (state, password) {
        state.password = password;
    },
    setPasswordConfirmation: function (state, passwordConfirm) {
        state.passwordConfirmation = passwordConfirm;
    },
    setInvite: function (state, invite) {
        state.invite = invite;
    },
    setAuthOptions: function (state, authOptions) {
        state.authOptions = authOptions;
    },
};
